import { createRoute } from '@tanstack/react-router';
import { loginParentRoute } from 'pages/shared/Login/loginParentRoute';

export const loginInvitationRoute = createRoute({
  getParentRoute: () => loginParentRoute,
  path: '/invitation',
}).lazy(() => import('pages/shared/Login/Invitation/Invitation').then((d) => d.Route));
